module.exports = __webpack_public_path__ + "11_hair_silver.eb55a1ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/11_hair_silver.png
// module id = 1qNX
// module chunks = 0